
import DisableableButton from '@/components/buttons/DisableableButton.vue';
import mediaFormFeatures from '@/mixins/mediaFormFeatures';

export default {
  components: { DisableableButton },
  mixins: [mediaFormFeatures],
  props: {
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      notEmptyRule: [(val: any) => (val || '').length > 0 || 'This field is required'],
    };
  },
};
